module.exports = __webpack_public_path__ + "video/800-1_SERF_2022_EmailRedFlags.2b050d5d.vtt";